interface AvatarProps {
  name?: string | null
  src?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

function getInitials(name: string | null | undefined): string {
  if (!name) return '?'
  return name
    .split(' ')
    .map((word) => word[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2) || '?'
}

function getColorFromName(name: string | null | undefined): string {
  const colors = [
    '#E53238',
    '#0064D2',
    '#86B817',
    '#F5AF02',
    '#007185',
    '#FF9900',
  ]

  if (!name) return colors[0]

  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }

  return colors[Math.abs(hash) % colors.length]
}

export function Avatar({ name, src, size = 'md', className = '' }: AvatarProps) {
  const sizeClass = size !== 'md' ? `avatar-${size}` : ''
  const displayName = name || 'User'
  const initials = getInitials(name)
  const bgColor = getColorFromName(name)

  if (src) {
    return (
      <div
        className={`avatar ${sizeClass} ${className}`.trim()}
        style={{ backgroundImage: `url(${src})`, backgroundSize: 'cover' }}
        title={displayName}
      />
    )
  }

  return (
    <div
      className={`avatar ${sizeClass} ${className}`.trim()}
      style={{ backgroundColor: bgColor }}
      title={displayName}
    >
      {initials}
    </div>
  )
}
